var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheBas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.772 14.144c-.461.084-.439-.411-.439 9.893v9.5l-3.067-3.06c-2.87-2.864-3.086-3.06-3.36-3.06-.545 0-.868.566-.583 1.022.093.148 1.793 1.891 3.779 3.874 3.361 3.354 3.631 3.604 3.898 3.604.267 0 .537-.25 3.898-3.604 1.986-1.983 3.685-3.724 3.776-3.87.201-.322.148-.625-.153-.861-.501-.394-.457-.428-3.787 2.895l-3.067 3.06v-9.509c0-8.938-.009-9.52-.146-9.677-.157-.18-.451-.261-.749-.207",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheBas);
export default __webpack_public_path__ + "static/media/fleche-bas.03915fe0236ba3d23f005bea5a666511.svg";
export { ForwardRef as ReactComponent };